var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-icon-button md-dense",attrs:{"id":"undo"},on:{"click":_vm.clickUndo}},[_c('md-icon',[_vm._v("undo")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }